import { Donuz } from "donuz-js/Donuz";
import M from "materialize-css";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import Loading from "@/components/Loading.vue";
import { Money } from "v-money"
import VueTheMask from 'vue-the-mask'

// @ is an alias to /src
export default {
    name: "register",
    components: {
        VueGoogleAutocomplete,
        Loading,
        Money,
    },
    data() {
        return {
            obj: {},
            client: {},
            autocomplete: "",
            address: {},
            branches: [],
            password: "",
            rules: false,
            customFields: [],
            text: {},
            check: {},
            select: {},
            textarea: {},
            data: {},
            configs: {},
            image: null,
            disabled: false,
            logged: false,
            loading: true,
            loadingRegister: false,
            money: {
                decimal: ",",
                thousands: ".",
                prefix: "R$ ",
                precision: 2,
                masked: false
            },
        };
    },
    async created() {
        this.obj = await this.getAdmins(this.$route.params.slug);
        this.obj = this.obj.estabelecimentos[0];
        let customFieldsResponse = await Donuz.customer.getCustomFields(this.obj.id);
        if (customFieldsResponse.status == 200) {
            this.customFields = customFieldsResponse.campos;
        }
        this.configs = await Donuz.settings.getSettings(
            (sessionStorage.length > 0 ? "meus_dados" : "cadastro"), this.obj.id
        );
        this.configs = this.configs.configuracoes;
        this.branches = await Donuz.branch.getBranchs(this.obj.id);
        this.branches = this.branches.filiais;

        var elems = document.querySelectorAll("select");
        var instances = M.FormSelect.init(elems);
        if (sessionStorage.length > 0) {
            this.logged = true;
            this.client = JSON.parse(atob(sessionStorage.getItem(btoa("cliente"))));

            if(!this.client.id_cliente){
                this.client.id_cliente =  this.client.id
            }
            this.client = await Donuz.customer.getInfoCustomer(sessionStorage.getItem(btoa("tokenCliente")), this.client.id_cliente, this.obj.id)
            this.client = this.client.clientes[0]
            this.customFields = this.client.campos_adicionais;
            this.client.time_torce = this.client.time
            this.client.tipo_cliente = this.client.tipo
            this.client.codigo_cliente = this.client.codigo
            this.image = this.client.foto;
            this.client.renda_mensal = parseFloat(this.client.renda_mensal).toFixed(2)
            if (this.client.cpf.trim() === '' && (this.client.cnpj != null && this.client.cnpj != undefined)) {
                this.client.cpf = this.client.cnpj
                this.$forceUpdate()
            }
            if (this.$refs.address != undefined)
                this.$refs.address.update(this.client.gm_endereco_completo);
            if (this.client.sexo != undefined)
                this.client.sexo = this.client.sexo.toLowerCase() == 'feminino' && this.client.sexo != null ? 1 : 2;
            if (this.client.dt_nascimento != undefined && this.client.dt_nascimento != null) {
                this.client.data_nascimento = this.client.dt_nascimento
            }

            if (this.customFields) {
                Object.entries(this.customFields).map((el) => {

                    switch (el[1].tipo) {
                        case 'checkbox':
                            this.check[el[0]] = []
                            if (el[1].respostas != null) {
                                el[1].respostas.map((element) => {
                                    el[1].opcoes.map((opcao) => {
                                        if (opcao.opcao == element) {
                                            this.check[el[0]].push(opcao.id)
                                        }
                                    })
                                })
                            }
                            break;
                        case 'select':
                            el[1].opcoes.map((opcao) => {
                                if (opcao.opcao == el[1].respostas) {
                                    this.select[el[0]] = opcao.id
                                }
                            })
                            break;
                        default:
                            break;
                    }

                })
            }
        }
        window.M.updateTextFields();
        this.loading = false;
    },
    updated() {
        var elems = document.querySelectorAll("select");
        var instances = M.FormSelect.init(elems);
        window.M.updateTextFields();
        M.Modal.init(document.querySelectorAll('.modal'));

    },
    methods: {
        submit: async function (e) {

            if (!this.logged) {
                if (this.client.senha != this.password) {
                    M.toast({
                        html: "As senhas não conferem",
                        classes: "red"
                    });
                    return false;
                }
                if (!this.rules) {
                    M.toast({
                        html: "Aceite o regulamento primeiro",
                        classes: "red"
                    });
                    return false;
                }
            }

            this.loadingRegister = true;


            this.client.adicional = {};
            this.client.campos_adicionais = {};
            this.client.adicional["data"] = [];
            this.client.adicional["checkbox"] = this.check;
            this.client.adicional["text"] = [];
            this.client.adicional["textarea"] = [];
            this.client.adicional["select"] = this.select;
            if (this.image != null) {
                this.client.foto = this.image
                    .replace("data:image/", "")
                    .replace(";base64", "");
            }
            if (this.customFields != null && this.customFields != undefined) {
                Object.values(this.customFields).map(val => {
                    switch (val.tipo) {
                        case "text":
                            this.client.adicional["text"][val.id] = val.respostas;
                            break;
                        case "data":
                            this.client.adicional["data"][val.id] = val.respostas;
                            break;
                        case "textarea":
                            this.client.adicional["textarea"][val.id] = val.respostas;
                            break;
                    }
                });
            }

            let result = null;
            if (this.logged) {
                result = await Donuz.customer.updateCustomer(
                    this.client,
                    sessionStorage.getItem(btoa("tokenCliente"))
                );
            } else {
                result = await Donuz.customer.signUp(this.client);
            }

            if (result.status == 200) {
                M.toast({
                    html: result.mensagem,
                    classes: "green"
                });

                if (this.logged) {
                    result = await Donuz.customer.getInfoCustomer(
                        sessionStorage.getItem(btoa("tokenCliente")),
                        this.client.cpf
                    );
                    if (result.status == 200) {
                        sessionStorage.setItem(btoa("cliente"), btoa(JSON.stringify(result.clientes[0])));
                    }
                    location.reload()
                } else {
                    let saldo = await Donuz.balance.getCustomerBalance(result.token);
                    result.clientes[0].saldo = parseFloat(saldo.saldo)
                        .toFixed(2)
                        .replace(".", ",");
                    sessionStorage.setItem(btoa("cliente"), btoa(JSON.stringify(result.clientes[0])));
                    sessionStorage.setItem(btoa("tokenCliente"), result.token);

                    location.href = this.baseUrl;
                }
            } else {
                M.toast({
                    html: result.mensagem,
                    classes: "red"
                });
            }

            this.loadingRegister = false;

        },
        getAddressData: function (addressData, placeResultData, id) {
            this.address = addressData;
            placeResultData.address_components.map(addr => {
                if (addr.types != undefined && addr.types != null) {
                    if (addr.types.includes("sublocality_level_1")) {
                        this.client.bairro = addr.long_name;
                    }
                    if (addr.types.includes("locality")) {
                        this.client.cidade = this.address.locality;
                    }
                }
            });
            this.client.endereco = this.address.route;
            this.client.cep = this.address.postal_code;
            this.client.numero = this.address.street_number;
            this.client.estado = this.address.administrative_level_1;
            this.client.pais = this.address.country;
            this.client.gm_endereco_completo = placeResultData.formatted_address;
            this.client.gm_latitude = this.address.latitude;
            this.client.gm_longitude = this.address.longitude;
        },
        filesChange(e) {
            this.client.delete_foto = null;
            this.disabled = true;
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.createImage(files[0]);
        },
        createImage(file) {
            var image = new Image();
            var reader = new FileReader();
            var vm = this;

            reader.onload = e => {
                vm.image = e.target.result;
                this.disabled = false;
            };
            reader.readAsDataURL(file);
        },
        removeImage: function (e) {
            this.image = " ";
            this.client.delete_foto = "sim";
        },
        update: function (type, id, val) {
            if (type == "text") {
                this.text[id] = val;
            }
            if (type == "date") {
                this.data[id] = val;
            }
            if (type == "textarea") {
                this.textarea[id] = val;
            }
        },
        change(comp, prop, id_field) {
            if (this.check[id_field] == undefined) {
                this.check[id_field] = [];
            }
            if (comp.target.checked) {
                this.check[id_field].push(prop.id)
            } else {
                var index = this.check[id_field].indexOf(prop.id);
                if (index > -1) {
                    this.check[id_field].splice(index, 1);
                }
            }
        },
        input(comp, id_field) {
            if (id_field == 'tipo_cliente') {
                this.client.tipo_cliente = comp.target.value
                this.client.tipo_de_cliente = comp.target.value
                this.client.tipo = comp.target.value
                this.$forceUpdate();
                return
            }
            if (this.select[id_field] == undefined) {
                this.select[id_field] = {};
            }
            if (comp.target.value != this.select[id_field]) {
                this.select[id_field] = comp.target.value
            }


        }
    }


};